import React, { FC, useContext, useEffect, useState } from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import { useQuery, useMutation } from 'react-query'
import ModalComponent from 'UI/Modal'
import Button from 'UI/Button/ButtonWithPreloader'
import RichContent from 'UI/RichContent'
import { UserContext } from 'contexts/userContext'
import { usePermission } from 'hooks/usePermission'
import { CHANGE_LOG_VIEW_PERM } from 'constants/permissions'
import { USER_ROLE } from 'constants/localStorageKeys'
import { getUnseenChangeLogEntry, markChangeLogEntrySeen } from 'services/changeLog'
import { IChangeLogHistoryItem } from 'typescript/interfaces/changeLog'
import { convertDate } from 'utils/formatters'

const useStyles = makeStyles(() => ({
  content: {
    width: '640px',
    maxWidth: '100%',
  },
  body: {
    marginTop: '1.5rem',
  },
}))

const WhatsNewPopup: FC = () => {
  const s = useStyles()
  const userContext = useContext(UserContext)
  const { hasPermission } = usePermission()
  const [isDismissed, setIsDismissed] = useState(false)

  const { data } = useQuery(['changelog-unseen', localStorage.getItem(USER_ROLE)], getUnseenChangeLogEntry, {
    enabled: Boolean(userContext.state.user) && hasPermission(CHANGE_LOG_VIEW_PERM),
    refetchOnWindowFocus: false,
    retry: false,
  })

  const [markSeenMut] = useMutation(markChangeLogEntrySeen)

  const entry = data && data.data ? (data.data as IChangeLogHistoryItem) : null
  const entryId = entry ? entry.id : null

  useEffect(() => {
    if (entryId) markSeenMut(entryId)
  }, [entryId])

  if (!entry || isDismissed) return null

  return (
    <ModalComponent open onClose={() => setIsDismissed(true)}>
      <Box className={s.content}>
        <Typography variant="h2" color="textSecondary">
          What&apos;s New
        </Typography>
        <Box mt="0.5rem">
          <Typography variant="h3" color="textSecondary">
            {entry.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {convertDate(entry.releaseDate)}
          </Typography>
        </Box>
        <RichContent html={entry.bodyHtml} className={s.body} />
        <Box mt="2rem" display="flex" justifyContent="flex-end">
          <Button color="primary" variant="contained" onClick={() => setIsDismissed(true)}>
            Got it
          </Button>
        </Box>
      </Box>
    </ModalComponent>
  )
}

export default WhatsNewPopup
